const accessRoute = {
  Resume_Form: {
    path: "/resume-form",
  },
};
export default accessRoute;
